import { TextAreaProps } from '.';
import { createUseStyles } from 'react-jss';
import { PRIMARY_STATUS_COLORS, SECONDARY_STATUS_COLORS } from '@tcl-argon-utils/utils';
import { Classes } from 'jss';
import { ActionPalette, BrandPalette, GrayscalePalette } from '@tcl-boron-colors/colors';

export const useTextAreaStyles: (
  data?: TextAreaProps & {
    theme?: Jss.Theme;
  },
) => Classes<'textArea'> = createUseStyles({
  textArea: ({ status = 'default', textAreaType = 'primary' }: TextAreaProps) => ({
    backgroundColor: SECONDARY_STATUS_COLORS[status],
    border: '1px solid',
    borderColor:
      status !== 'default'
        ? PRIMARY_STATUS_COLORS[status]
        : textAreaType === 'primary'
        ? 'transparent'
        : ActionPalette[400],
    borderRadius: textAreaType === 'primary' ? '20px' : '3px',
    fontFamily: 'Nolan-Next, Helvetica, sans-serif',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
    color: BrandPalette[700],
    height: '100%',
    outline: 'none',
    maxHeight: 'inherit',
    maxWidth: '100%',
    paddingTop: '12px',
    paddingBottom: '12px',
    paddingLeft: '16px',
    transition: 'background-color 0.3s, box-shadow 0.3s',
    resize: 'none',
    boxShadow: textAreaType === 'primary' && status === 'default' ? `0px 1px 3px 1px ${GrayscalePalette[300]}` : 'none',
    '&:hover': {
      borderColor: ActionPalette[500],
      backgroundColor: SECONDARY_STATUS_COLORS[status],
    },
    '&:focus-within, &:active': {
      borderColor: ActionPalette[500],
      backgroundColor: status === 'default' ? GrayscalePalette[200] : SECONDARY_STATUS_COLORS[status],
    },
    '&::placeholder': {
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '16px',
      color: GrayscalePalette[500],
    },
  }),
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
});
